<ion-item lines="none" [class.error]="isInvalid" (click)="selectRef.open()">
  <ion-label [style.fontSize.px]="fontSizePx">{{ label }}</ion-label>
  <ion-select
		#selectRef
    slot="end"
    [placeholder]="placeholder"
    [interface]="interface"
    [multiple]="multiple"
    [required]="required"
    [formControl]="control"
    (ionChange)="ionChange.emit($event)"
    (click)="$event.stopPropagation()"
  >
    @for (opt of options; track opt.value) {
      <ion-select-option
        [value]="opt.value"
        [disabled]="opt.disabled ?? false">
        {{ opt.label }}
      </ion-select-option>
    }
  </ion-select>
</ion-item>

@if (isInvalid && errorMessages.length) {
  <div class="error-message">
    @for (msg of errorMessages; track $index) {
      <div>{{ msg }}</div>
    }
  </div>
}
